export interface PickupShortcutAvailability {
  directory_branch_id: string | null;
  branch_available?: boolean;
  available_service_categories?: string[] | null;
}
/** Only server-confirmed current branches can be reused for a new pickup. */
export function pickupShortcutAvailable(point: PickupShortcutAvailability, category: string) {
  return !point.directory_branch_id || (point.branch_available === true && point.available_service_categories?.includes(category) === true);
}
